"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FluidFormatters = exports.formatShorthandNumber = exports.dateFormats = void 0;
/**
 * Given a number or string, number of decimal places and a locale (default to 'en-US')
 * @param value
 * @param decimalPlaces
 * @param locale
 */
const date_fns_1 = require("date-fns");
const helpers_1 = require("../helpers");
const i18n_1 = require("../i18n");
const enums_1 = require("../structs/enums");
function stringToNumber(value) {
    if (typeof value === "string") {
        value = Number(value);
    }
    return value;
}
function formatNumber(value, decimalPlaces = 0, locale = enums_1.FluidLocale.UNITED_STATES) {
    return intlNumberFormat(value, {
        locale,
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces
    });
}
/**
 * Formats a number with the given options using the international number format utility.
 * @param value
 * @param numberOptions
 */
function intlNumberFormat(value, numberOptions) {
    const locale = (0, i18n_1.getFluidLocale)((numberOptions === null || numberOptions === void 0 ? void 0 : numberOptions.locale) || enums_1.FluidLocale.UNITED_STATES).numberFormat;
    const numberToFormat = stringToNumber((numberOptions === null || numberOptions === void 0 ? void 0 : numberOptions.wholeOnly) ? applyRounding(value, numberOptions.roundingMethod) : value);
    return new Intl.NumberFormat(locale, numberOptions).format(numberToFormat);
}
/**
 * Applies rounding to a number based on the rounding method supplied.
 * @param value
 * @param roundingMethod
 */
function applyRounding(value, roundingMethod) {
    if (!roundingMethod) {
        return value;
    }
    // default behaviour should be down, per the API contract
    switch (roundingMethod) {
        case enums_1.FluidRoundingMethod.UP:
            return Math.ceil(value);
        case enums_1.FluidRoundingMethod.DOWN:
            return Math.floor(value);
        case enums_1.FluidRoundingMethod.ROUND:
            return Math.round(value);
        default:
            return Math.floor(value);
    }
}
;
/**
 * Given a number, converts to percentage, and adds the percentage symbol.
 * @param value
 * @param decimalPlaces
 */
function formatPercentage(value, decimalPlaces = 0) {
    const percentageValue = stringToNumber(value) * 100;
    return percentageValue.toFixed(decimalPlaces) + '%';
}
function formatDate(date, locale = enums_1.FluidLocale.UNITED_STATES, formatStr = exports.FluidFormatters.dateFormats.SHORT) {
    var _a;
    if (date === '' || (0, helpers_1.isNullOrUndefined)(date)) {
        date = new Date();
    }
    return (0, date_fns_1.format)(typeof date === 'string' ? (0, date_fns_1.parseISO)(date) : date, formatStr, { locale: ((_a = (0, i18n_1.getFluidLocale)(locale)) === null || _a === void 0 ? void 0 : _a.dateLocale) || (0, i18n_1.getFluidLocale)(enums_1.FluidLocale.UNITED_STATES).dateLocale })
        .replace(/\b\w/g, (c) => c.toUpperCase());
}
exports.dateFormats = {
    SHORT: 'P',
    LONG: 'PPPP',
    SHORT_TIME: 'Pp',
    LONG_TIME: 'PPPPpppp',
    DATEPICKER_FORMAT: 'yyyy-MM-dd'
};
/**
 * Converts shorthand string representations of numbers into the corresponding numerical value
 * @param value - the Prop value to convert to numerical value
 */
const formatShorthandNumber = (value) => {
    value = String(value === 'v' ? 0 : value);
    const number = parseFloat(value);
    const unit = value.charAt(value.length - 1).toLowerCase();
    switch (unit) {
        case 'k': {
            return number * 1000;
        }
        case 'm': {
            return number * 1000000;
        }
        case 'b': {
            return number * 1000000000;
        }
        case '.': {
            return 0;
        }
        default: {
            return number;
        }
    }
};
exports.formatShorthandNumber = formatShorthandNumber;
exports.FluidFormatters = {
    stringToNumber,
    formatNumber,
    intlNumberFormat,
    applyRounding,
    formatPercentage,
    formatDate,
    formatShorthandNumber: exports.formatShorthandNumber,
    dateFormats: exports.dateFormats
};
